import React from "react";

// import "./layout.css";
import "./custom.css";

const Layout = ({ children }) => {
  return (
    <main>
      {children}
    </main>
  )
}

export default Layout
